var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6854 2.75012C20.2619 2.75012 23.6351 4.12512 26.1949 6.63599C28.7667 9.15882 30.238 12.674 30.2499 16.2729C30.2739 23.8773 24.1016 30.1425 16.506 30.2501L16.3026 30.2501C12.7261 30.2501 9.35291 28.8751 6.80507 26.3643C4.23332 23.8414 2.76203 20.3262 2.75007 16.7273C2.72615 9.13491 8.89837 2.85773 16.494 2.75012L16.6854 2.75012ZM16.3026 29.0545L16.494 29.0545C23.4437 28.9588 29.0777 23.2197 29.0657 16.2729C29.0538 12.9849 27.7141 9.79254 25.3696 7.48493C23.049 5.20124 19.9629 3.94577 16.6974 3.94577L16.5179 3.94577C9.56822 4.04143 3.93427 9.78056 3.94623 16.7273C3.9582 20.0153 5.29792 23.2077 7.6424 25.5153C9.96296 27.799 13.0371 29.0545 16.3026 29.0545Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4942 13.511C16.8291 13.511 17.0923 13.774 17.0923 14.1088L17.0923 22.4783C17.0923 22.8131 16.8291 23.0762 16.4942 23.0762C16.1593 23.0762 15.8961 22.8131 15.8961 22.4783L15.8961 14.1088C15.8961 13.774 16.1593 13.511 16.4942 13.511Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.482 10.5219C16.9844 10.5219 17.3791 10.9045 17.3911 11.3947C17.403 11.6338 17.3074 11.861 17.1519 12.0404C16.9724 12.2197 16.7452 12.3154 16.5179 12.3273L16.5059 12.3273C16.5059 12.3393 16.4461 12.3273 16.4222 12.3154C15.9676 12.2675 15.6208 11.8968 15.6088 11.4544C15.5968 11.2153 15.6925 10.9882 15.848 10.8088C16.0155 10.6175 16.2428 10.5219 16.482 10.5219Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInformation);
export default __webpack_public_path__ + "static/media/alert-information.20665ea8b605b38e64011d79311c802d.svg";
export { ForwardRef as ReactComponent };